var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnMenuMore = function SvgIcnMenuMore(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 15.65V9.975C33 8.2125 32.2 7.5 30.2125 7.5H25.1625C23.175 7.5 22.375 8.2125 22.375 9.975V15.6375C22.375 17.4125 23.175 18.1125 25.1625 18.1125H30.2125C32.2 18.125 33 17.4125 33 15.65Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 29.7125V24.6625C33 22.675 32.2 21.875 30.2125 21.875H25.1625C23.175 21.875 22.375 22.675 22.375 24.6625V29.7125C22.375 31.7 23.175 32.5 25.1625 32.5H30.2125C32.2 32.5 33 31.7 33 29.7125Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6248 15.65V9.975C18.6248 8.2125 17.8248 7.5 15.8373 7.5H10.7873C8.79985 7.5 7.99985 8.2125 7.99985 9.975V15.6375C7.99985 17.4125 8.79985 18.1125 10.7873 18.1125H15.8373C17.8248 18.125 18.6248 17.4125 18.6248 15.65Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6248 29.7125V24.6625C18.6248 22.675 17.8248 21.875 15.8373 21.875H10.7873C8.79985 21.875 7.99985 22.675 7.99985 24.6625V29.7125C7.99985 31.7 8.79985 32.5 10.7873 32.5H15.8373C17.8248 32.5 18.6248 31.7 18.6248 29.7125Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnMenuMore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_menu_more.b7137629.svg";
export { ForwardRef as ReactComponent };